import React, { useEffect, useState } from "react";
import { Table, Space, Button, Modal, notification, Input, Row, Col, Tooltip, Pagination } from "antd";
import { EyeOutlined, EditOutlined, DeleteOutlined, SearchOutlined } from "@ant-design/icons";

import blformService from "../../../services/blform-service";
import { Link } from "react-router-dom";
import { checkPermission } from "../../../utils/permissions";
import { useDebounce } from "../../../hooks/useDebounce";
import { changeDocumentTitle } from "../../../utils/title";

function BlForm() {
  const [blForms, setBlForms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 1,
    pageSize: 10,
  });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalshow, setIsModalShow] = useState(false);
  const [selectedDeleteRecord, setSelectedDeleteRecord] = useState(null);

  const [modalLoader, setModalLoader] = useState(false);
  const [id, setId] = useState(0);

  const debouncedSearch = useDebounce(search, 500);

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Booking No",
      dataIndex: "booking_no",
      key: "booking_no",
    },
    {
      title: "Container No",
      dataIndex: "container_nos",
      key: "container_nos",
      render: (text) => <p>{text ? text : "-"}</p>,
    },

    {
      title: "Action",
      key: "Action",
      render: (text, record) => (
        <Space size="small" className="flex justify-center">
          <Link to={`/operations/bl-forms/edit/${record.id}`}>
            <Tooltip title='Edit'>
              {/* <Button type="primary" size="small"> */}
              <EditOutlined />
              {/* </Button> */}
            </Tooltip>

          </Link>

          <Link to={`/operations/bl-forms/view/${record.id}`}>
            <Tooltip title='View'>
              {/* <Button type="primary" size="small"> */}
              <EyeOutlined />
              {/* </Button> */}
            </Tooltip>
          </Link>

          {checkPermission('DELETE_BLFORM') && <Tooltip title='Delete'>
            {/* <Button type="primary" size="small" onClick={() => showModal(record)}> */}
            <DeleteOutlined onClick={() => showModal(record)} />
            {/* </Button> */}
          </Tooltip>}

          <Button
            disabled={!record.showGlobexBtn}
            type="default"
            size="small"
            onClick={() => { setIsModalVisible(true); setId(record.id) }}
          >
            Globex Button
          </Button>
          {record?.sended_at && record?.sended_by && (
            <div className="flex gap-2 items-center">
              <p>{record.sended_at}</p>
              <p>{record.sended_by}</p>
            </div>
          )}
        </Space>
      ),
    },
  ];

  const showModal = (record) => {
    setSelectedDeleteRecord(record);
    setIsModalShow(true);
  };

  const handleOk = async () => {
    setModalLoader(true);
    const { success } = await blformService.sendToGlobex(id);
    setModalLoader(false);
    if (success ?? false) {
      notification.success({
        message: "Data Sent Successfully ",
        description: "Your data was send",
        duration: 1,
      });
      handleCancel();
      initialize(pagination.current, pagination.pageSize)
    }
  };

  const handleDelete = async () => {
    setLoading(true);
    if (!selectedDeleteRecord || !selectedDeleteRecord.id) {
      console.error("No entry selected for deletion.");
      return;
    }
    const response = await blformService.deleteForm(selectedDeleteRecord.id);
    setLoading(false);
    if (response.success) {
      notification.success({
        message: "Deleted Successfully!",
        description: response.message,
        placement: "topRight",
      });
      setBlForms((prevData) =>
        prevData.filter((item) => item.id !== selectedDeleteRecord.id)
      );
      initialize(pagination.current, pagination.pageSize);
    } else {
      console.error("Failed to delete the customer.");
    }
    setIsModalShow(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsModalShow(false);
    setSelectedDeleteRecord(null);
    setId(0);
  };

  const initialize = async (page = 1, pageSize = pagination.pageSize) => {
    setLoading(true);
    const { success, data } = await blformService.fetch(page, pageSize, debouncedSearch);
    setLoading(false);
    if (success) {
      setBlForms(data.data);
      setPagination((prev) => ({
        ...prev,
        total: data.total,
        current: page,
        pageSize,
      }));
    }
  };


  useEffect(() => {
    changeDocumentTitle(" BL Forms");
    initialize(pagination.current, pagination.pageSize);
  }, [debouncedSearch]);

  return (
    <div
      style={{
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Row gutter={16} style={{ paddingTop: "5px" }}>
        <Col span={12}>

        </Col>
      </Row>

      <div className="flex justify-between items-center">
        <h1 style={{ fontWeight: "bold" }} className="pl-2 pt-3">
          BL Forms
        </h1>
        <Input
          placeholder="Search by Booking No & Container No"
          prefix={<SearchOutlined />}
          style={{
            width: "33%",
            borderRadius: "20px",
            fontSize: 14,
            margin: 10
          }}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* Send To Globex */}
      <Modal
        title={<div style={{ textAlign: "center" }}>Confirm</div>}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        centered
        style={{
          padding: "20px",
        }}
        width={300}
        footer={
          <div className="flex justify-center gap-3">
            <Button
              type="default"
              onClick={handleCancel}
              style={{ width: "30%" }}
            >
              Cancel
            </Button>
            <Button type="primary" loading={modalLoader} onClick={handleOk} style={{ width: "30%" }}>
              Confirm
            </Button>
          </div>
        }
      >
        <p style={{ textAlign: "center" }}>
          Are you sure you want to send this?
        </p>
      </Modal>

      <Table
        columns={columns}
        // pagination={{
        //   current: pagination.current,
        //   total: pagination.total,
        //   pageSize: pagination.pageSize,
        //   onChange: (page) => initialize(page),
        //   showSizeChanger: false,
        // }}
        loading={loading}
        dataSource={blForms}
        rowKey="id"
        style={{ marginTop: "10px" }}
        pagination={false}
        footer={() => (
          <div className="flex justify-between items-center text-xs ">
            <div className=" text-gray-600">
              Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
              {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
              {pagination.total} entries
            </div>
            <Pagination
              current={pagination.current}
              total={pagination.total}
              pageSize={pagination.pageSize}
              showSizeChanger={false}
              onChange={(page) => initialize(page, pagination.pageSize, search)}
              itemRender={(current, type, originalElement) => {
                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                return originalElement;
              }}
            />
          </div>
        )}
      />
      <Modal
        title={<div style={{ textAlign: "center" }}>Confirm</div>}
        open={isModalshow}
        onOk={handleDelete}
        onCancel={handleCancel}
        centered
        styles={{
          body: {
            padding: "20px",
          },
        }}
        width={300}
        footer={
          <div className="flex justify-center gap-3">
            <Button
              type="default"
              onClick={handleCancel}
              style={{ width: "30%" }}
              loading={loading}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={handleDelete}
              style={{ width: "30%" }}
              loading={loading}
            >
              Confirm
            </Button>
          </div>
        }
      >
        <p style={{ textAlign: "center" }}>
          Are you sure you want to delete this?
        </p>
      </Modal>
    </div>
  );
}

export default BlForm;
